import React from 'react';

export const CustomAmountInput = ({
  value,
  handleChange,
  isError,
}: {
  value: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isError: boolean;
}) => {
  return (
    <div className='w-full'>
      <label
        htmlFor='amount'
        className='leading-8 text-customBlack block mb-2'
        aria-label='Enter amount in dollars'
      >
        Amount
      </label>

      <div
        className='w-full relative rounded-lg box-border leading-8'
        style={{ fontSize: 15 }}
      >
        <span
          className='absolute'
          aria-hidden='true'
          style={{
            top: 9,
            left: 16,
            color: '#BDBDBD',
          }}
        >
          $
        </span>

        <input
          type='text'
          name='amount'
          className='w-full rounded-lg py-3 pl-11 pr-6'
          style={{
            height: 36,
            boxSizing: 'border-box',
            border: `1px solid ${isError ? '#F43746' : '#AFB2B5'}`,
          }}
          value={value}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};
